module.exports = __webpack_public_path__ + "media/images/icons/result-page-b4ea785dd418e91be0118b4fb12db9af.svg";